import { useQuery } from '@tanstack/react-query';

import { SAMLConfig } from '@graylog/enterprise-api';

const useSAMLBackendDetails = (backendId: string) => {
  const { isLoading, isError, data } = useQuery({
    queryKey: [backendId],
    queryFn: () => SAMLConfig.getBackendDetails(backendId),
  });

  if (isError) {
    return {
      isLoading: false,
      details: undefined,
    };
  }

  return {
    isLoading: isLoading,
    details: data,
  };
};

export default useSAMLBackendDetails;
